import { useState } from "react";
import Modal from "../common/Modal";
import { hashPassword } from "../../common/api/auth";
import { useToast } from "../../hooks/useToast";


function ModalChangePassword({ user, onClose, onSave, hasManagementPermissions }) {
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [password, setPassword] = useState("");
  const toast = useToast();

  const handleSubmit = async () => {
    if (!user || !user.USER || !user.COD_ID || !user.EMAIL) {
      toast.error("No se ha cargado correctamente la información del usuario.");
      return;
    }

    if (newPassword.trim() === "" || confirmPassword.trim() === "") {
      toast.error("Debes introducir y confirmar la nueva contraseña.");
      return;
    }

    if (newPassword !== confirmPassword) {
      toast.error("Las contraseñas no coinciden.");
      return;
    }

    if (!password) {
      toast.error("Debes introducir tu contraseña actual.");
      return;
    }

    try {
      const CURR_PASS_HASH = await hashPassword(password);
      const NEW_PASS_HASH = await hashPassword(newPassword);

      let updatedUser = {
        COD_ID: user.COD_ID,
        USER: user.USER,
        //EMAIL: user.EMAIL,
        //ACTIVO: user.ACTIVO ?? "1",
        //GRUPOS: user.GRUPOS ?? [],
        //CURR_PASS_HASH,
        NEW_PASS_HASH,
      };
      if (hasManagementPermissions && password.trim()) {
        updatedUser.CURR_PASS_HASH = await hashPassword(password);
      }
      //console.log(updatedUser)
      const success = await onSave(updatedUser);
      //console.log(success)
      if (success) {
        toast.success("Contraseña actualizada correctamente.");
        onClose();
      } else {
        toast.error("La contraseña actual no es correcta. No se pudo guardar el cambio.");
      }
    } catch (err) {
      toast.error(err.message || "Error al guardar cambios de contraseña.");
      console.error("Error al guardar contraseña:", err);
    }
  };


  return (
    <Modal title={`Cambio de contraseña: ${user.USER}`} onClose={onClose}>
      <div className="input-group">
        <label className="label">Nueva contraseña</label>
        <input
          type="password"
          className="input"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
        />
      </div>

      <div className="input-group">
        <label className="label">Confirmar nueva contraseña</label>
        <input
          type="password"
          className="input"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
        />
      </div>

      <div className="input-group">
        <label className="label">
          Introduzca su contraseña para guardar los cambios
        </label>
        <input
          type="password"
          className="input"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
      </div>

      <div
        className="input-group_row"
        style={{ justifyContent: "center", gap: "1rem" }}
      >
        <span className="boton_opciones" onClick={handleSubmit}>
          Aceptar
        </span>
        <span className="boton_cancelar" onClick={onClose}>
          Cancelar
        </span>
      </div>
    </Modal>
  );
}

export default ModalChangePassword;
